import useOrientationHelper from "@src/utils/orientation-helper";
import { tabletSize } from "@src/utils/screensize-helper";
import React from "react";
import { View } from "react-native";
import Background from "./background";
import Login from "./login";
import Logo from "./logo";
import LogoTop from "./logo-top";
import { SignInProvider } from "./provider";
import useStyles from "./styles.css";
import { useDeviceSize, DEVICE_SIZES } from "rn-responsive-styles";
  

const SignIn = () => {
  const styles = useStyles();
  const isTablet = tabletSize();
  let isLandScape = useOrientationHelper();
  const device_size = useDeviceSize();
  // if (DEVICE_SIZES.XS !== device_size) {
  //   isLandScape = true
  // }
  // else if (DEVICE_SIZES.SM !== device_size) {}

  return (
    <SignInProvider>
      <View style={styles.container}>
        <Background />
        <View style={styles.v_body}>
          {isTablet ? <LogoTop/> : <Logo /> }
          <Login />
        </View>
      </View>
    </SignInProvider>
  );
};

export default SignIn;
